import './ford-account-info.scss';

const FordAccountInfoSkeleton = () => (
    <div
        className="osb-v3-ford-account-login-container"
        data-testid="ford-account-info-skeleton"
    >
        <div
            className="ford-account-section-title"
            style={{
                backgroundColor: '#e2e2e2',
                height: '32px',
                width: '70%',
                borderRadius: '4px',
                color: 'transparent',
            }}
        ></div>

        <div
            className="ford-account-section-desc"
            style={{
                backgroundColor: '#e2e2e2',
                height: '20px',
                width: '90%',
                marginTop: '10px',
                borderRadius: '4px',
            }}
        ></div>
        <div
            className="ford-account-section-desc"
            style={{
                backgroundColor: '#e2e2e2',
                height: '20px',
                width: '80%',
                marginTop: '8px',
                borderRadius: '4px',
            }}
        ></div>

        <div className="login-btn" style={{ marginTop: '50px' }}>
            <div
                className="fm-btn__light"
                style={{
                    backgroundColor: '#e2e2e2',
                    height: '48px',
                    borderRadius: '8px',
                }}
            ></div>
        </div>
    </div>
);

export default FordAccountInfoSkeleton;
